import propertyDeveloperAPI from '@/api/PropertyDeveloperAPI'

const state = {
  items: [],
  loadedItem: {}
}

const getters = {
  items (state) {
    return state.items.sort((itemA, itemB) => {
      return itemA.dateModified > itemB.dateModified
    })
  },
  loadedItem (state) {
    return state.loadedItem
  }
}

const actions = {
  list ({ commit }) {
    commit('setLoading', true, { root: true })
    propertyDeveloperAPI.list()
      .then(resp => {
        console.log(resp)
        commit('setLoading', false, { root: true })
        commit('setItems', resp.data.developers)
      })
      .catch(error => {
        commit('setLoading', false, { root: true })
        commit('setError', error, { root: true })
        console.log(error)
      })
  },
  view ({ commit, dispatch }, id) {
    commit('setLoading', true, { root: true })
    propertyDeveloperAPI.view(id)
      .then(resp => {
        console.log(resp)
        commit('setLoading', false, { root: true })
        commit('setLoadedItem', resp.data.developer)
      })
      .catch(error => {
        commit('setLoading', false, { root: true })
        commit('setError', error, { root: true })
        console.log(error)
      })
  }
}

const mutations = {
  setItems (state, items) {
    state.items = items
  },
  addItem (state, payload) {
    state.items.push(payload)
  },
  setLoadedItem (state, payload) {
    state.loadedItem = payload
  },
  setItem (state, payload) {
    const item = state.items.find(item => {
      return item.id === payload.id
    })
    item.name = payload.name
    item.dateModified = payload.dateModified
    item.isLocked = payload.isLocked
  },
  delete (state, itemId) {
    state.items = state.items.filter(function (item) { return item.id !== itemId })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
